import * as React from 'react';
/**
 *
 * Original name: space full
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=4464%3A60
 *
 */
export const SpaceFullLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M3.975 12c0-2.833.723-4.903 2.19-6.23l.49.437v-.001l6.328 5.64-.998 1.12-5.589-4.982C5.81 8.991 5.528 10.321 5.528 12c0 4.476 1.996 6.472 6.472 6.472 4.476 0 6.472-1.996 6.472-6.472 0-4.476-1.996-6.472-6.472-6.472-1.296 0-2.384.168-3.276.514L7.439 4.896c1.202-.616 2.72-.92 4.561-.92 5.4 0 8.025 2.624 8.025 8.024 0 5.4-2.625 8.025-8.025 8.025S3.975 17.4 3.975 12Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
